import $ from "jquery";

function init_select2(id, data = [], placeholder = 'Seleccionar una opción'){
    let target = $('#' + id);

    // 1. Destruir y vaciar correctamente
    if (target.hasClass("select2-hidden-accessible")) {
        target.select2('destroy');
    }
    target.empty(); // Limpia los <option> actuales

    // 2. Preparar la lista con IDs consistentes
    let list = [{ id: '', text: placeholder }, ...data];

    // 3. Inicializar
    target.select2({
        data: list,
        theme: "classic",
        width: '100%',
        tokenSeparators: [',', ' ']
    });

    // 4. Resetear valor
    target.val('').trigger('change');
};

function getProductos(init = false) {
    const bounceType = $('#product_product_type').val();
    const bounceName = $('#bounce_name').val();
    const container = document.getElementById("products-container");
    if (!container) return;
    if (init === true && (undefinedOrNull(bounceType) || bounceType === '')) return;

    const products = JSON.parse(container.dataset.products);
    // [{"id":2,"product_type":"Aceite de motor","name":"JVM LUBRICANTES SAE-50 SA","purchase_price":"90.0","sell_price":null,"batteries_location_id":1,"company_id":1,"user_id":4,"sold":false,"created_at":"2026-01-28T17:44:53.758-06:00","updated_at":"2026-01-28T17:44:53.758-06:00"},...

    let list = products.filter(p => p.product_type === bounceType);
    const result = [...new Map(list.map(item => [item.name, item])).values()];

    cyellow(result.map(p => ({'id': p.name, 'text': p.name})), 'init_select2')
    // init_select2(Array) = [{"name":"JVM LUBRICANTES SAE-50 SA","text":"JVM LUBRICANTES SAE-50 SA"},{"name":"asdfasdf","text":"asdfasdf"}]

    init_select2('product_name', result.map(p => ({'id': p.name, 'text': p.name})), 'Seleccionar producto');
    if(!undefinedOrNull(bounceName)) {
        $('#product_name').val(bounceName).trigger('change');
    }
}

function destroyProductos() {
    if(document.getElementById('products-sale')) {
        $(document).off('select2:select', '#product_product_type', getProductos);
        document.removeEventListener('turbolinks:load', setupProductos);
        document.removeEventListener('turbolinks:before-cache', destroyProductos);
    }
}

function setupProductos() {
    if(document.getElementById('products-sale')) {
        $(document).on('select2:select change', '#product_product_type', getProductos);
        getProductos(true);
    }
}

document.addEventListener('turbolinks:load', setupProductos);
document.addEventListener('turbolinks:before-cache', destroyProductos);